import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API_BASE });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("gges_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export default api;

// ---------- Auth ----------
export const signup = (data) => api.post("/auth/signup", data).then((r) => r.data);
export const verifyOtp = (data) => api.post("/auth/verify-otp", data).then((r) => r.data);
export const resendOtp = (data) => api.post("/auth/resend-otp", data).then((r) => r.data);
export const login = (data) => api.post("/auth/login", data).then((r) => r.data);
export const forgotPassword = (data) => api.post("/auth/forgot-password", data).then((r) => r.data);
export const resetPassword = (data) => api.post("/auth/reset-password", data).then((r) => r.data);
export const getMe = () => api.get("/auth/me").then((r) => r.data);
// ---------- Locations ----------
export const getCountries = () => api.get("/locations/countries").then((r) => r.data);
export const getStates = (country = "India") => api.get(`/locations/states?country=${encodeURIComponent(country)}`).then((r) => r.data);
export const getCities = (state) => api.get(`/locations/cities?state=${encodeURIComponent(state)}`).then((r) => r.data);

// ---------- Payment ----------
export const paymentConfig = () => api.get("/payment/config").then((r) => r.data);
export const createOrder = (data = {}) => api.post("/payment/create-order", data).then((r) => r.data);
export const previewCoupon = (code) => api.post("/payment/preview-coupon", { coupon_code: code }).then((r) => r.data);
export const verifyPayment = (data) => api.post("/payment/verify", data).then((r) => r.data);
export const paymentStatus = () => api.get("/payment/status").then((r) => r.data);
export const myReferral = () => api.get("/referral/me").then((r) => r.data);
